var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTriangleWarning = function SvgTriangleWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49027 0.299065C8.71682 -0.0996888 9.28318 -0.0996882 9.50973 0.299066L17.9203 15.1028C18.1468 15.5016 17.8636 16 17.4105 16H0.589461C0.136368 16 -0.146813 15.5016 0.0797338 15.1028L8.49027 0.299065Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90244 12.3621C7.90244 12.0809 8.00204 11.8445 8.20126 11.6531C8.40048 11.4617 8.64072 11.366 8.92197 11.366C9.22275 11.366 9.46689 11.4617 9.65439 11.6531C9.84579 11.8406 9.9415 12.077 9.9415 12.3621C9.9415 12.6551 9.84775 12.8953 9.66025 13.0828C9.47275 13.2664 9.22665 13.3582 8.92197 13.3582C8.63681 13.3582 8.39462 13.2645 8.1954 13.077C8.00009 12.8895 7.90244 12.6512 7.90244 12.3621ZM7.98447 7.94415V4.79767H9.8829V7.94415L9.47275 10.6922H8.39462L7.98447 7.94415Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triangle-warning.62fd71d75bc4fda62093e9a91171d29a.svg";